var classList = require('dom-classlist');
var pubsub = require('pubsub');
var gsap = require('gsap');
var Slider = require('partials/slider.js');
var project = require('partials/project.js');
var ScrollTo = require('partials/scroll-to');

module.exports = function (el) {
	var _el = el,
		_btTriggerAnim = _el.querySelector('.triggerAnim'),
		_btClose = _el.querySelector('.close'),
		_scndBloc = _el.querySelector('.content_slide'),
		_projectForm = el.querySelector('form.project')



    function addHandlers(){
		_btTriggerAnim.addEventListener('click', reverseAnimIn);

		_btClose.addEventListener('click', reverseAnimOut);

		if(_projectForm) project(_projectForm, _el)
    }

	/*open*/
	function reverseAnimIn(e){
        e.preventDefault();
		var bloc = _el;

		var blocH = bloc.querySelector('.content').offsetHeight + _scndBloc.offsetHeight;

		TweenMax.to(el, 1, {height : blocH, onComplete:function(){
			classList(bloc).remove('noopen');
	        classList(bloc).add('open');
			el.style.height = '';
			//
			pubsub.emit('update:posAnim') //svg-animation.js
		}})

		ScrollTo(_scndBloc, 1)

    }

    function reverseAnimOut(e){
		var bloc = _el;

		var blocH = bloc.querySelector('.content').offsetHeight;

		TweenMax.to(el, .5, {height : blocH, onComplete:function(){
			classList(bloc).remove('open');
	        classList(bloc).add('noopen');
			el.style.height = '';
			//
			pubsub.emit('update:posAnim') //svg-animation.js
		}})

		ScrollTo(bloc, 1)

    }
    addHandlers()
}
